import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RootScopeData } from '../../core/rootscope-data';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.css']
})
export class ConfirmationPopupComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  constructor(private rootScopeService: RootScopeService) { }

  @Input() modalTitle: string;
  @Input() modalMessage: string;

  @Output() eventClicked = new EventEmitter<Event>();
  @Output() skipAndGo = new EventEmitter<Event>();

  ngOnInit() {
    this.getRootScopeData();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
    }
  closePopUp(event: Event) {
     this.skipAndGo.emit(event);
     this.rootScopeData.enablePopup = false;

    }

  onClickYes(event: Event): void {
      this.eventClicked.emit(event);
    }

}
